import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoltPaywall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 12L10 3V8H16L10 17V12H4Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinejoin: "round"
	})
});
export default SvgBoltPaywall;
